import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/index.scss'
import './i18n'
import { ThemeProvider } from '@mui/material'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import ErrorBoundary from './components/reusable/Error/ErrorBoundary'
import { store } from './redux/store'
import { globalTheme } from './styles/muiThemes/globalTheme'
// import * as serviceWorkerRegistration from './testing/serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <ThemeProvider theme={globalTheme}>
              <App />
            </ThemeProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister()
// serviceWorkerRegistration.register()
